@use 'themes/westfield' as *;

.notificationLink {
  color: currentColor;
}
